// formSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../actions/configApi";
import { getCache, setCache } from "../../../src/util";
const SLICE_NAME = "form";
// Thunk para envio dos dados do formulário
export const submitForm = createAsyncThunk(
  "form/submitForm",
  async (
    { formData, images, selectedAttributes, selectedTipo },
    { rejectWithValue },
  ) => {
    try {
      const formDataObj = new FormData();

      // Adiciona os campos do formData ao FormData
      Object.keys(formData).forEach((key) => {
        formDataObj.append(key, formData[key]);
      });

      // Adiciona as imagens como uma lista simples de arquivos
      images.forEach((image) => {
        formDataObj.append("images[]", image.file); // `images[]` mantém a estrutura de array esperada no backend
      });

      // Adiciona os atributos selecionados como uma lista simples
      Object.entries(selectedAttributes).forEach(
        ([attributeId, attributeValueId]) => {
          formDataObj.append(
            `selectedAttributes[${attributeId}]`,
            attributeValueId,
          );
        },
      );

      // Adiciona os tipos selecionados como uma lista simples
      selectedTipo.forEach((tipo) => {
        formDataObj.append("selectedTipo[]", tipo);
      });

      // Envia o FormData para o backend
      const response = await api.post("produtoStore", formDataObj, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (page, { rejectWithValue }) => {
    // Defina a página padrão como 1
    try {
      const response = await api.get(`/products?page=${page}`); // Inclua a página na URL
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const fetchAtributes = createAsyncThunk(
  "products/fetchAtributes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/products/atributes`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const editProduct = createAsyncThunk(
  "products/editProduct",
  async (
    { productId, formData, images, selectedAttributes, selectedTipo },
    { rejectWithValue },
  ) => {
    try {
      console.log(formData, "dados");
      const formDataObj = new FormData();
      /// productId, formData, images, selectedAttributes, selectedTipo
      // Adiciona os campos do formData ao FormData
      Object.keys(formData).forEach((key) => {
        formDataObj.append(key, formData[key]);
      });
      // console.log(images,'imagesnoreducer')
      // Adiciona as imagens como uma lista simples de arquivos
      images.forEach((image) => {
        if (image.file instanceof File) {
          // Adiciona o arquivo binário no campo 'images[]'
          formDataObj.append("images[]", image.file);
        } else if (typeof image?.url === "string") {
          // Adiciona a URL no campo 'existingImages[]'
          formDataObj.append("existingImages[]", image?.url);
        }
      });

      // Adiciona os atributos selecionados como uma lista simples
      Object.entries(selectedAttributes).forEach(
        ([attributeId, attributeValueId]) => {
          formDataObj.append(
            `selectedAttributes[${attributeId}]`,
            attributeValueId,
          );
        },
      );

      // Adiciona os tipos selecionados como uma lista simples
      selectedTipo.forEach((tipo) => {
        formDataObj.append("selectedTipo[]", tipo.id);
      });
      // Envia o FormData para o backend
      const response = await api.post(
        `productsUpdate/${productId}`,
        formDataObj,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const deleteProduct = createAsyncThunk(
  "products/deleteProduct",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/products/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const filterProduct = createAsyncThunk(
  "products/filter",
  async (id, { dispatch, rejectWithValue }) => {
    const endpoint = `/typesAttributes/${id}`;
    const params = {}; // sem query, mas deixo pra manter a assinatura do util

    try {
      const resp = await api.get(endpoint);
      return resp.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Falha ao filtrar produtos" },
      );
    }
  },
);
//vitrini
export const fetchFilteredProducts = createAsyncThunk(
  "produtos/fetchFilteredProducts",
  async ({ filters, typeId }) => {
    const response = await api.post("products/filter", { filters, typeId });
    return response.data; // Retorna os produtos filtrados
  },
);
//modelos
export const fetchALlModelos = createAsyncThunk(
  "produtos/fetchALlModelos",
  async () => {
    const response = await api.get("modelosAll");
    return response.data; // Retorna os produtos filtrados
  },
);

export const fetchAllProducts = createAsyncThunk(
  "produtos/fetchAllProducts",
  async (page = 1, { dispatch, rejectWithValue }) => {
    // Defina a página padrão como 1

    const endpoint = "/products/productsAll";
    const params = { page: String(page) };
    const cached = await getCache(endpoint, params);
    try {
      const headers = {};
      if (cached?.etag) headers["If-None-Match"] = cached.etag;

      const resp = await api.get(`${endpoint}?page=${page}`, { headers });

      if (resp.status === 304 && cached?.data) {
        console.log("nada mudou — devolve o cache");
        return cached.data;
      }

      // 200 OK — atualiza cache (guarde o ETag se veio)
      const etag = resp.headers?.etag || resp.headers?.ETag || null;
      setCache(endpoint, params, resp.data, { etag, ttl: 5 * 60_000 }); // TTL 5 min
      return resp.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const produtoSlice = createSlice({
  name: "form",
  initialState: {
    formData: {},
    images: [],
    products: [],
    modelos: [],
    deviceAttributes: [],
    atributos: [],
    loading2: false,
    loading3: false,
    loading4: false,
    errorAPi: null,
    showModal: false, // Controle do modal de adicionar
    showEditModal: false,
    totalPage: "",
    filter: [],
    status: "",
    isRefreshing: false,
  },
  reducers: {
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    setLoad: (state, action) => {
      //console.log('setLoad disparado')
      state.loading4 = true;
    },
    setImages: (state, action) => {
      state.images = action.payload;
    },
    setAttributes: (state, action) => {
      state.deviceAttributes = action.payload;
    },
    openAddModal: (state) => {
      state.showModal = true;
    },
    closeAddModal: (state) => {
      state.showModal = false;
    },
    openEditModal: (state) => {
      state.showEditModal = true;
      //state.editProductData = action.payload;  // Armazena os dados do produto a ser editado
    },
    closeEditModal: (state) => {
      state.showEditModal = false;
      state.editProductData = null;
    },
    clearApiError: (state) => {
      state.errorAPi = null;
    },

    hydrateFromCache: (state, action) => {
      const p = action.payload || {};
      if (p.products !== undefined) state.products = p.products;
      if (p.modelos !== undefined) state.modelos = p.modelos;
      if (p.attributes !== undefined) state.filter = p.attributes;
      if (p.totalPage !== undefined) state.totalPage = p.totalPage;
      state.loading4 = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitForm.pending, (state) => {
        state.loading2 = true;
      })
      .addCase(submitForm.fulfilled, (state, action) => {
        state.status = action.payload.message;
        state.products = action.payload.product;
        state.loading2 = false;
        state.errorAPi = false;
        state.showModal = false;
      })
      .addCase(submitForm.rejected, (state, action) => {
        // state.status = 'failed';
        state.errorAPi = action.payload?.errors || {}; // Captura mensagens de erro de validação do Laravel
        state.loading2 = false;
        state.status = false;
      })
      // fetchProducts
      .addCase(fetchProducts.pending, (state) => {
        state.loading2 = true;
        state.error = null;
        state.loading3 = true;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading2 = false;
        state.products = action.payload;
        state.loading3 = false;
        state.totalPage = action.payload?.total;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading2 = false;
        state.error = action.payload;
        state.loading3 = false;
      })
      ///atributos
      .addCase(fetchAtributes.pending, (state) => {
        // state.loading2 = true;
        state.error = null;
        //state.loading3 = true;
      })
      .addCase(fetchAtributes.fulfilled, (state, action) => {
        //console.log("chamou aqui");
        //state.loading2 = false;
        console.log(action.payload?.attributes, "action.payload");
        state.atributos = action.payload?.attributes || [];
        // state.loading3 = false;
        //state.totalPage = action.payload?.total
      })
      .addCase(fetchAtributes.rejected, (state, action) => {
        state.loading2 = false;
        state.error = action.payload;
        //state.loading3 = false;
      })
      .addCase(editProduct.pending, (state) => {
        state.loading2 = true;
      })
      .addCase(editProduct.fulfilled, (state, action) => {
        state.loading2 = false;
        state.products = action.payload.product;
        state.showEditModal = false;
        state.status = action.payload.message;
      })
      .addCase(editProduct.rejected, (state, action) => {
        state.loading2 = false;
        state.error = action.payload;
      })
      //delete
      .addCase(deleteProduct.pending, (state) => {
        state.loading3 = true;
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.loading3 = false;
        state.products = action.payload.product;
        // state.showEditModal = false;
        state.status = action.payload.message;
      })
      .addCase(deleteProduct.rejected, (state, action) => {
        state.loading3 = false;
        state.error = action.payload;
      })
      //vitrine
      .addCase(filterProduct.pending, (state) => {
        state.loading4 = true;
      })
      .addCase(filterProduct.fulfilled, (state, action) => {
        state.loading4 = false;
        state.filter = action.payload?.attributes ?? [];
        state.products = action.payload.products;
        state.modelos = action.payload?.modelos ?? [];
        // state.showEditModal = false;
        //state.status = action.payload.message;
      })
      .addCase(filterProduct.rejected, (state, action) => {
        state.loading4 = false;
        state.error = action.payload;
      })
      //filtros
      .addCase(fetchFilteredProducts.pending, (state) => {
        state.loading4 = true;
      })
      .addCase(fetchFilteredProducts.fulfilled, (state, action) => {
        state.loading4 = false;
        state.products = action.payload.products;
      })
      .addCase(fetchFilteredProducts.rejected, (state, action) => {
        state.loading4 = false;
        state.error = action.payload;
      })
      //modelos
      /*.addCase(fetchALlModelos.pending, (state) => {
        state.loading4 = true;
      })*/
      .addCase(fetchALlModelos.fulfilled, (state, action) => {
        state.loading4 = false;
        state.modelos = action.payload.modelos;
      })
      /* .addCase(fetchALlModelos.rejected, (state, action) => {
        state.loading4 = false;
        state.error = action.payload;
      })*/

      //todos os produtos
      .addCase(fetchAllProducts.pending, (state) => {
        // detecta se já temos algo para mostrar
        // const p = state.products;
        /*const hasData =
          (Array.isArray(p) && p.length > 0) ||
          (Array.isArray(p?.data) && p.data.length > 0) || // caso paginator
          !!p?.total;

        if (hasData) {
          // já há dados na tela -> NÃO mostra spinner grande
          state.isRefreshing = true;  // um indicador discreto “Atualizando...”
          // não mexe no loading4 (mantém false)
        } else {
          // primeira carga (sem cache) -> spinner normal
        state.isRefreshing = false;
        }*/
        state.loading4 = true;
      })
      .addCase(fetchAllProducts.fulfilled, (state, action) => {
        state.loading4 = false;
        state.isRefreshing = false;
        state.products = action.payload.products;
        // state.filter = action.payload.attributes;
        state.totalPage = action.payload?.products?.total;
        //state.modelos = action.payload?.modelos;
        // state.products = action.payload.products;
      })
      .addCase(fetchAllProducts.rejected, (state, action) => {
        state.loading4 = false;
        state.isRefreshing = false;
        state.error = action.payload;
      });
    //tipos
  },
});

export const {
  setFormData,
  setImages,
  setAttributes,
  openAddModal,
  closeAddModal,
  openEditModal,
  closeEditModal,
  clearApiError,
  hydrateFromCache,
} = produtoSlice.actions;

export default produtoSlice.reducer;
